<template>
  <div>
    <v-dialog v-model="visible" max-width="800px">
      <v-card>
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>健康告知</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <ul class="health-list">
            <li>本保险项下被保险人均满足健康告知的要求：</li>
            <li>1.近一年内无健康检查异常（如血液、超声、影像检查、病理检查等）或2年内住院的被保险人；</li>
            <li>2.过去两年内被保险人投保人身保险或健康保险时，没有出现被保险公司拒保、延期或者附加相关条件承保的情况；</li>
            <li>3.被保险人目前及过往未患有或被告知患有下列疾病：
              <ul>
                <li>癌症、恶性肿瘤、白血病；癫痫病、精神病、神经系统疾病（包括帕金森氏病、阿尔兹海默症）；任何眼耳鼻喉口腔疾病或不正常；结核病、慢性支气管炎、呼吸系统或肺部疾病；心功能不全、高血压病、冠心病、心肌病等任何心脏及血管疾病；胃肠肝胆脾疾病或肝炎携带者（包括急慢性肝炎及暴发型肝炎）；肾病、肾结石或任何生殖泌尿系统疾病；糖尿病、甲状腺疾病或任何内分泌代谢系统疾病；性病、HIV抗体阳性者、艾滋病及其并发症；风湿病、关节炎等骨关节系统疾病；任何身体不正常、瘫痪、残疾、畸形、缺损、受伤或功能性缺损疾病；重大器官移植；严重烧烫伤；其他任何严重慢性疾病。 </li>
              </ul>
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>